import { Component, Vue } from "vue-property-decorator"
import { MoreData } from '@/types/views/more.interface'
// import {  } from "@/components" // 组件
import activity from '@/api/activity'
import app from "@/api/app";
import {getNavigationHeight} from "@/utils/common";

@Component({})
export default class MyActivity extends Vue {

  // data
  private popShow: boolean = false;
  private popShow2: boolean = false;
  private activityList: MoreData[] = []
  private orderId: string = ""
  private communityId: any = localStorage.getItem("communityId");
  private cityCode: any = localStorage.getItem("cityCode");
  private launchArea: any = localStorage.getItem("launchArea");
  private token: any = localStorage.getItem("token");
  // private isSourceApp: string | (string | null)[] = ""
  private isSourceApp: any = localStorage.getItem("isSourceApp");
  private headerHeight: string = '0'
  created(){
    this.isSourceApp= this.$route.query.isSourceApp
    if(this.isSourceApp==='app'){
      this.communityId = this.$route.query.communityId;
      this.token= this.$route.query.token;
      this.cityCode = this.$route.query.cityCode;
      this.launchArea = this.$route.query.launchArea;   // 1为"区投放" 2为"城市投放"
      localStorage.setItem("communityId", this.communityId);
      localStorage.setItem("token", this.token);
      localStorage.setItem("cityCode", this.cityCode);
      localStorage.setItem("launchArea", this.launchArea);
      localStorage.setItem("isSourceApp", this.isSourceApp);
    }

  }
  mounted() {
    //
    this.headerHeight = getNavigationHeight()
    this.myList(1);
  }

  // 查看活动
  checkActivity(id: string) {
    this.$router.push({ name: 'activityDetail', query: { id: id, path: 'mine', communityId: localStorage.getItem("communityId"), token: localStorage.getItem("token") } });
  }

  // 取消报名pop
  cancelActivity(item: any) {
    console.log(item.enrollStatus, '=====enrollStatus')
    if (item.enrollStatus == "2") {
      this.popShow2 = true
      return
    }

    this.popShow = true;
    this.orderId = item.orderId;
  }

  // 取消报名确定
  confirmCancel() {
    let params = {
      "orderId": this.orderId,
    };
    activity.cancelEnroll(params).then(res => {
      if (res.returnCode === "0") {
        this.popShow = false;
        this.myList(1);
      } else {
        this.$toast.fail(res.returnMsg);
      }
    });
    this.popShow = false;
  }

  myList(page: number) {
    let params = {
      "pageNo": page,
      "pageSize": 10000,
    };
    activity.myList(params).then(res => {
      if (res.returnCode === "0") {
        console.log('this.activityList活动列表',this.activityList)
        this.activityList = res.data.records;
      } else {
        this.$toast.fail(res.returnMsg);
      }
    });
  }

  // 返回
  back() {
    if(localStorage.getItem("isSourceApp")== 'app'){
      console.log(1)
      app.goBack();
      localStorage.setItem("isSourceApp", "")
    }else{
      console.log(2)
      this.$router.push({ name: 'more', query: { communityId: localStorage.getItem("communityId"), launchArea:localStorage.getItem("launchArea"),cityCode:localStorage.getItem("cityCode"),areaCode:localStorage.getItem("areaCode"),token: localStorage.getItem("token")} })
    }

  }

}
